import { ExerciseButton } from "@/Components/Exercises/ExerciseLibrary";
import { Exercise } from "@/Components/Exercises/exerciseSchema";
import { ClientExercise } from "@/types/exercise";
import { createContext, useContext } from "react";

export type ExercisePickerOptions = {
    title: string;
    overrideButtons?: ExerciseButton[];
};

const initialExercisePickerContext = {
    selectedExercises: {} as Record<number, Exercise | null>,
    attachExercise: async (
        _otherUserId: number,
        _exerciseId: Exercise["id"],
    ) => {},
    showExercisePicker: (_options?: ExercisePickerOptions) => {},
    clearSelectedExercise: (_otherUserId: number) => {},
    makeExerciseForClient: async (_exercise: Exercise, _clientId: number) =>
        ({}) as ClientExercise,
};

export const ExercisePickerContext = createContext(
    initialExercisePickerContext,
);

export function useExercisePicker(otherUserId: number) {
    const {
        selectedExercises,
        attachExercise,
        showExercisePicker,
        clearSelectedExercise,
        makeExerciseForClient,
    } = useContext(ExercisePickerContext);

    return {
        selectedExercise: selectedExercises[otherUserId] ?? null,
        attachExercise: (exerciseId: Exercise["id"]) =>
            attachExercise(otherUserId, exerciseId),
        showExercisePicker,
        clearSelectedExercise: () => clearSelectedExercise(otherUserId),
        makeExerciseForClient,
    };
}
